export const ROLL_EFFECT = 1;
export const MACROS_EFFECT = 2;
export const PALETTE_EFFECT = 3;
export const PLAYHEAD_EFFECT = 4;

// modes
export const ALWAYS_OFF  = 1;
export const SYNCED  = 2;
export const ALWAYS_ON = 3;
